module.exports = __webpack_public_path__ + "img/clerk_route_tarif_1.509ac1a9.png";